import { useEffect, useState } from "react"
import { Layer, Source } from "react-map-gl/mapbox"
import type { ICommune } from "@/types/explore"

interface ProjectsLayerProps {
  commune?: ICommune
  statuses: string[]
  color: string
  sourceId: string
}

export const ProjectsLayer = ({ commune, statuses, color, sourceId }: ProjectsLayerProps) => {
  const [geoJsonData, setGeoJsonData] = useState<GeoJSON.FeatureCollection>({
    type: "FeatureCollection",
    features: [],
  })

  useEffect(() => {
    if (!commune?.code) {
      setGeoJsonData({ type: "FeatureCollection", features: [] })
      return
    }

    const fetchProjects = async () => {
      try {
        const params = new URLSearchParams()
        params.set("commune", commune.code!)
        params.set("statuses", statuses.join(","))

        const res = await fetch(`/api/explore/projects?${params.toString()}`)
        if (!res.ok) return

        const data = await res.json()
        setGeoJsonData(data)
      } catch (err) {
        console.error("Error fetching projects:", err)
      }
    }

    fetchProjects()
  }, [commune?.code, statuses.join(",")])

  return (
    <Source id={sourceId} type="geojson" data={geoJsonData}>
      <Layer
        id={`${sourceId}-fill`}
        type="fill"
        filter={["!=", ["geometry-type"], "Point"]}
        paint={{
          "fill-color": color,
          "fill-opacity": 0.35,
        }}
      />
      <Layer
        id={`${sourceId}-outline`}
        type="line"
        filter={["!=", ["geometry-type"], "Point"]}
        paint={{
          "line-color": color,
          "line-width": 2,
        }}
      />
      <Layer
        id={`${sourceId}-point`}
        type="circle"
        filter={["==", ["geometry-type"], "Point"]}
        paint={{
          "circle-radius": 8,
          "circle-color": color,
          "circle-stroke-color": "#fff",
          "circle-stroke-width": 2,
          "circle-opacity": 0.9,
        }}
      />
    </Source>
  )
}
